var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.settings)?_c('span',{staticClass:"text-danger"},[_vm._v("\n  [CURRENCY SETTINGS NOT LOADED]\n")]):(_vm.value !== null)?_c('span',[_c('span',{class:_vm.amountClass},[_vm._v("\n    "+_vm._s(_vm.amount)+"\n  ")]),(_vm.showCurrency)?_c('span',{class:_vm.currencyClass},[_vm._v("\n    "+_vm._s(_vm.currency)+"\n  ")]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }